{
    "button.copy": "コピー",
    "button.email": "メールで共有",
    "button.share": "シェア",
    "button.sms": "SMS",
    "footer.poweredBy": "<linkText>Ice Cream Social<\/linkText> を搭載",
    "footer.privacyPolicy": "プライバシーポリシー",
    "footer.termsAndConditions": "規約と条件",
    "offer.hint": "{conversionGoal, plural, one {#友達が購入} two {#友達が購入} few {#友達が購入} many {#友達が購入} other {#友達が購入}}の場合、報酬を受け取ります!",
    "optInMessage": "参加して友達と共有するには、オファーと報酬の最新情報を連絡する方法をお知らせください",
    "order.confirmed": "注文番号{orderId}が確認されました!",
    "order.details": "注文の詳細を見る",
    "share.email.duplicateError": "おっと！そのメールはすでに追加されています。",
    "share.email.heading": "メールで友達を招待する",
    "share.email.inputLabel": "友達のメールアドレス",
    "share.email.inputSubmit": "入る",
    "share.email.invitesSubmit": "招待状を送る",
    "share.email.moreOptions": "その他の共有オプション",
    "share.email.subheading": "友達のメールアドレスを下に入力してください",
    "share.general.help": "<bold>問題がありますか? <\/bold>デバイスにインストールされていない場合、アプリが開かない場合があります。代わりに、個人用リンクで<bold2>シェア<\/bold2>を使用してみてください",
    "share.general.linkLabel": "個人リンクを使用してどこでも共有",
    "share.general.otherOptions": "または、これらのプラットフォームで今すぐ共有",
    "thankyou.dismissCTA": "解散",
    "thankyou.heading": "共有してくれてありがとう！",
    "thankyou.message": "あなたはチャンピオンです！報酬の進行状況に関する最新情報を受信トレイに送信します。",
    "thankyou.reminder": "共有を続けたい場合は、後でいつでもこのオファーにアクセスできます。",
    "thankyou.shareCTA": "共有を続ける",
    "unlock.consentExplanation": "ご提供いただいた情報をもとにご連絡いたします。登録はいつでも解除できますが、オファーに関する最新情報を見逃す可能性があります",
    "unlock.consentPolicyExplanation": "私たちはあなたのプライバシーを尊重します。お客様の情報がどのように使用されるかについては、 <linkText>プライバシーおよび Cookie ポリシー<\/linkText>をお読みください。",
    "unlock.emailConsentOptIn": "最新情報をメールで受け取る",
    "unlock.error.invalidEmail": "正しいメールアドレスを入力してください",
    "unlock.error.noConsent": "このオファーに参加するには、電子メール通信に同意してください",
    "unlock.input": "メールアドレス",
    "unlock.label": "オファーを有効にする",
    "share.general.copySuccess": "✨ リンクコピーしました！"
}